export const calendarConfig = {
  colors: [
    '#e55c5c',
    '#f2973d',
    '#e5b82e',
    '#7cbf39',
    '#5092e5',
    '#4c63d9',
    '#ad57d9',
    '#cca166',
    '#ffece9',
    '#ebf2ff',
    '#e0f4ff',
  ],
  defaultColor: '#d9d9d9',
};
